// src/pages/HousekeepingModal.jsx
import React, { useEffect } from "react";
import { Modal, Form, Select, Input } from "antd";
import notify from "../utils/notify";

const HousekeepingModal = ({
  open = false,
  task,
  onClose,
  onSave,
  statusOptions = [],
  statusLabels = {},
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;

    form.setFieldsValue({
      status: task?.status,
      notes: task?.notes || "",
    });
  }, [open, task, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSave({
        ...task,
        ...values,
      });
    } catch (err) {
      //console.log("Validation failed:", err);
      notify.error({
        message: "Validation Error",
        description: "Please check the form fields",
      });
    }
  };

  return (
    <Modal
      title={`Edit task #${task?.housekeepingTaskId || ""}`}
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Save changes"
      width={480}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item name="status" label="Status" rules={[{ required: true, message: "Status is required" }]}>
          <Select placeholder="Select status">
            {statusOptions.map((status) => (
              <Select.Option key={status} value={status}>
                {statusLabels[status] || status}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="notes" label="Notes">
          <Input.TextArea rows={4} placeholder="Add notes" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default HousekeepingModal;
